import { render, staticRenderFns } from "./Mailgun.vue?vue&type=template&id=ab4e0ccc&scoped=true"
import script from "./Mailgun.vue?vue&type=script&lang=js"
export * from "./Mailgun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4e0ccc",
  null
  
)

export default component.exports